// Deep-link handling for the native apps. When a Universal Link (iOS) / App
// Link (Android) opens the app, route to the matching in-app screen. On web
// this is a no-op (the browser already handles the URL).
import { Capacitor } from '@capacitor/core';

export async function initDeepLinks(navigate) {
  if (!Capacitor.isNativePlatform()) return () => {};
  try {
    // Dynamic import: @capacitor/app is a dependency, but keep it lazy so the
    // web bundle never depends on native plugin internals at load time.
    const { App } = await import('@capacitor/app');
    const handle = await App.addListener('appUrlOpen', (event) => {
      try {
        const url = new URL(event.url);
        const path = `${url.pathname}${url.search}${url.hash}`;
        // The app's react-router routes mirror the website paths, so navigating
        // to the same path opens the right screen.
        if (path && path !== '/') navigate(path);
      } catch { /* ignore malformed URLs */ }
    });
    return () => { try { handle.remove(); } catch { /* noop */ } };
  } catch (e) {
    console.warn('deepLinks init failed:', e?.message);
    return () => {};
  }
}
